import { EXTRA_LONG_DAY_OF_WEEK_FORMAT, LONG_DAY_OF_WEEK_FORMAT, EXTRA_LONG_MONTH_DAY_FORMAT, LONG_MONTH_DAY_FORMAT, SHORT_MONTH_DAY_FORMAT, EXTRA_SHORT_MONTH_DAY_FORMAT, TIME_FORMAT } from './patterns.js';
import formatTZ from 'date-fns-tz/format';
import utcToZonedTime from 'date-fns-tz/utcToZonedTime';

/**
 * Format an absolute date, optionally with the day of the week, month and day of month, year, and time component.
 * This function is only intended to be used internally within `@deal/date-utils`.
 *
 * Defaults:
 * - `format` = "short"
 * - `includeDayOfWeek` = "false"
 * - `includeMonthAndDay` = "true"
 * - `includeTime` = "false"
 * - `includeYear` = "false"
 * - `ianaTimeZone` = "undefined"
 */
function formatDateCustom(date, options) {
    const { format = 'short', ianaTimeZone, includeDayOfWeek = false, includeMonthAndDay = true, includeTime = false, includeYear = false, } = options || {};
    let convertedDate = new Date(date);
    // if setting the time zone, convert the time to the zoned time
    if (ianaTimeZone) {
        convertedDate = utcToZonedTime(convertedDate, ianaTimeZone);
    }
    let formatPattern = '';
    if (includeDayOfWeek) {
        switch (format) {
            case 'extra-short':
            case 'short':
            case 'long':
                formatPattern += LONG_DAY_OF_WEEK_FORMAT;
                break;
            case 'extra-long':
                formatPattern += EXTRA_LONG_DAY_OF_WEEK_FORMAT;
                break;
        }
    }
    if (includeDayOfWeek && (includeMonthAndDay || includeYear)) {
        formatPattern += ', ';
    }
    if (includeMonthAndDay) {
        switch (format) {
            case 'extra-short':
                formatPattern += EXTRA_SHORT_MONTH_DAY_FORMAT;
                break;
            case 'short':
                formatPattern += SHORT_MONTH_DAY_FORMAT;
                break;
            case 'long':
                formatPattern += LONG_MONTH_DAY_FORMAT;
                break;
            case 'extra-long':
                formatPattern += EXTRA_LONG_MONTH_DAY_FORMAT;
                break;
        }
    }
    if (includeMonthAndDay && includeYear) {
        switch (format) {
            case 'extra-short':
            case 'short':
                formatPattern += '/';
                break;
            case 'long':
            case 'extra-long':
                formatPattern += ', ';
                break;
        }
    }
    if (includeYear) {
        switch (format) {
            case 'extra-short':
                formatPattern += 'yy';
                break;
            case 'short':
            case 'long':
            case 'extra-long':
                formatPattern += 'yyyy';
                break;
        }
    }
    if (includeTime) {
        formatPattern += `, ${TIME_FORMAT}`;
    }
    if (ianaTimeZone) {
        formatPattern += ' zzz';
    }
    return formatTZ(convertedDate, formatPattern, { timeZone: ianaTimeZone });
}

export { formatDateCustom };
//# sourceMappingURL=format-date-custom.js.map
